/* External Deps */
import { FC, ReactElement } from "react";
import { Outlet } from "react-router-dom";

const Storage: FC = (): ReactElement => {
  return <Outlet />;
};

export default Storage;